import Swal from 'sweetalert2';

const OpportunityTypeDialog = {
  showTypeSelectionDialog: (callback) => {
    Swal.fire({
      title: '<strong>Selecciona el tipo de publicación</strong>',
      html: `
        <div style="text-align: center; margin: 20px 0;">
          <p style="margin-bottom: 30px; font-size: 16px; color: #555;">
            ¿Qué tipo de publicación deseas crear?
          </p>
          <div style="display: flex; justify-content: center; gap: 20px; margin-top: 20px;">
            <button id="service-btn" style="
              padding: 20px;
              border: none;
              border-radius: 12px;
              background: linear-gradient(135deg, #0488AF 0%, #09274A 100%);
              color: white;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 180px;
            ">
              <div style="font-size: 40px; margin-bottom: 15px;">
                <svg width="1em" height="1em" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
              </div>
              <span style="font-weight: 500;">Servicio</span>
              <span style="font-size: 12px; opacity: 0.8; margin-top: 5px;">Profesional o laboral</span>
            </button>
            <button id="product-btn" style="
              padding: 20px;
              border: none;
              border-radius: 12px;
              background: linear-gradient(135deg, #1BBB55 0%, #0A5C36 100%);
              color: white;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 180px;
            ">
              <div style="font-size: 40px; margin-bottom: 15px;">
                <svg width="1em" height="1em" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
                </svg>
              </div>
              <span style="font-weight: 500;">Bien/Producto</span>
              <span style="font-size: 12px; opacity: 0.8; margin-top: 5px;">Físico o material</span>
            </button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#C42251',
      width: '600px',
      background: '#ffffff',
      backdrop: `
        rgba(4, 136, 175, 0.1)
      `,
      customClass: {
        container: 'swal-type-selection',
        popup: 'swal-popup-custom'
      },
      didOpen: () => {
        document.getElementById('service-btn').addEventListener('click', () => {
          Swal.close();
          OpportunityTypeDialog.showServiceSubTypeDialog(callback);
        });
        document.getElementById('product-btn').addEventListener('click', () => {
          Swal.close();
          callback('Bien/Producto', '');
        });
      }
    });
  },

  showServiceSubTypeDialog: (callback) => {
    Swal.fire({
      title: '<strong>Selecciona el tipo de servicio</strong>',
      html: `
        <div style="text-align: center; margin: 20px 0;">
          <p style="margin-bottom: 30px; font-size: 16px; color: #555;">
            ¿Estás ofreciendo o solicitando este servicio?
          </p>
          <div style="display: flex; justify-content: center; gap: 20px; margin-top: 20px;">
            <button id="offer-btn" style="
              padding: 20px;
              border: none;
              border-radius: 12px;
              background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%);
              color: white;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 180px;
            ">
              <div style="font-size: 40px; margin-bottom: 15px;">
                <svg width="1em" height="1em" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <span style="font-weight: 500;">Oferta</span>
              <span style="font-size: 12px; opacity: 0.8; margin-top: 5px;">Ofreces este servicio</span>
            </button>
            <button id="demand-btn" style="
              padding: 20px;
              border: none;
              border-radius: 12px;
              background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
              color: white;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 180px;
            ">
              <div style="font-size: 40px; margin-bottom: 15px;">
                <svg width="1em" height="1em" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                </svg>
              </div>
              <span style="font-weight: 500;">Demanda</span>
              <span style="font-size: 12px; opacity: 0.8; margin-top: 5px;">Solicitas este servicio</span>
            </button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#C42251',
      width: '600px',
      background: '#ffffff',
      didOpen: () => {
        document.getElementById('offer-btn').addEventListener('click', () => {
          Swal.close();
          callback('Servicio', 'Oferta');
        });
        document.getElementById('demand-btn').addEventListener('click', () => {
          Swal.close();
          callback('Servicio', 'Demanda');
        });
      }
    });
  }
};

export default OpportunityTypeDialog;